import React from 'react';
import './MobileTables.css';
import { MobileTable } from '../MobileTable';
import { StringUtilService } from '../../../../../shared/src/services/util/string-util.service';

export const MobileTables = ({
    tableRows,
    loyaltyLevels,
}) => {
    return <div className="loyalty-level-tables-mobile">
        {loyaltyLevels.map((levelData, levelIndex) => <MobileTable
            key={StringUtilService.stringToKebabCase(levelData.description)}
            levelData={levelData}
            levelIndex={levelIndex}
            rowsData={tableRows}
        />)}
    </div>;
};
